import { Suspense } from "react";
import UniversalLoading from "@/components/loading/UniversalLoading";
import ParsnipPage from "@/components/parsnip/pages/ParsnipPage";
import { usePicassoAuth } from "@/hooks/common/usePicassoAuth";

export const PicassoParsnipView = () => {
  const { userEmail, isAdmin } = usePicassoAuth();

  return (
    <Suspense
      fallback={
        <div className="overflow-y-hidden">
          <UniversalLoading 
            variant="dashboard" 
            message="Loading Picasso Parsnip..." 
          />
        </div>
      }
    >
      <ParsnipPage userEmail={userEmail} isAdmin={isAdmin} />
    </Suspense>
  );
};

export default PicassoParsnipView;
